import React, { useEffect, useState } from "react";
import CartEmptyImage from "../emptycart.png";
import { products } from "../data";
import { message } from "antd";

function Cart() {
  const [cartItems, setCartItems] = useState(JSON.parse(sessionStorage.getItem("cartItems")) || []);
  const [total, setTotal] = useState(0);
  const incrementQty = (productId) => {
    let originalPrice;
    products.map((item) => {
      if (item.productId === productId) {
        originalPrice = item.price;
      }
    });
    cartItems.map((item) => {
      if (item.productId === productId) {
        item.qty = item.qty + 1;
        item.price = originalPrice * item.qty;
      }
    });
    sessionStorage.setItem("cartItems", JSON.stringify(cartItems));
    setCartItems([...cartItems]);
  };

  const decrementQty = (productId) => {
    let originalPrice;
    products.map((item) => {
      if (item.productId === productId) {
        originalPrice = item.price;
      }
    });
    cartItems.map((item) => {
      if (item.productId === productId) {
        if (item.qty > 1) {
          item.qty = item.qty - 1;
          item.price = originalPrice * item.qty;
        }
      }
    });
    sessionStorage.setItem("cartItems", JSON.stringify(cartItems));
    setCartItems([...cartItems]);
  };

  useEffect(() => {
    let total = 0;
    if (cartItems != null) {
      cartItems.map((item) => {
        total = total + item.price;
      });
    }
    setTotal(total);
  }, [cartItems]);

  const removeProduct = (productId) => {
    const temp = cartItems.filter((item) => item.productId != productId);
    if (temp.length == 0) {
      sessionStorage.removeItem("cartItems");
    } else {
      sessionStorage.setItem("cartItems", JSON.stringify(temp));
    }
    setCartItems(temp);
  };
  const addToWishList = (product) => {
    const temp = products.filter((item) => item.productId == product.productId);
    console.log(temp);
    product.price = temp[0].price;
    product.qty = 1;

    if (sessionStorage.getItem("wishlistItems") == null) {
      sessionStorage.setItem("wishlistItems", JSON.stringify([product]));
    } else {
      const wishlistItems = JSON.parse(sessionStorage.getItem("wishlistItems"));
      const check = wishlistItems.filter((item) => item.productId == product.productId);
      if (check.length == 0) {
        sessionStorage.setItem("wishlistItems", JSON.stringify([...wishlistItems, product]));
      }
    }
    removeProduct(product.productId);
  };
  return (
    <>
      <div className="container">
        <h3 className="mt-5">My Cart</h3>
        {cartItems?.length == 0 ? (
          <div className="d-flex justify-content-center" style={{ height: "40vh" }}>
            <img src={CartEmptyImage} />
          </div>
        ) : (
          <>
            {cartItems?.map((product) => {
              return (
                <div className="row mt-2" style={{ boxShadow: "1px 1px 10px 1px grey", borderRadius: "5px" }} id={product.productId}>
                  <div className="col-lg-3 col-md-3 col-4 col-sm-4  d-flex flex-column justify-content-center">
                    <img src={product.url} className="m-2" />
                  </div>
                  <div className="col-lg-4 col-md-5 col-8 col-sm-8 d-flex flex-column justify-content-center">
                    <h5>{product.productName}</h5>
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-4 col-sm-12 d-flex flex-column justify-content-center">
                        <h6 className="">Quantity:</h6>
                      </div>
                      <div className="col-lg-6 col-md-8 col-sm-12  d-flex flex-column justify-content-center">
                        <div className="input-group">
                          <span className="input-group-btn">
                            <button
                              type="button"
                              className="quantity-right-plus btn btn-dark px-2"
                              style={{ padding: "6px" }}
                              onClick={() => decrementQty(product.productId)}
                            >
                              <span className="fa fa-minus" />
                            </button>
                          </span>
                          <input type="text" name="quantity" className="form-control text-center" value={product.qty} disabled />
                          <span className="input-group-btn">
                            <button
                              type="button"
                              className="quantity-left-minus btn btn-dark px-2"
                              style={{ padding: "6px" }}
                              onClick={() => incrementQty(product.productId)}
                            >
                              <span className="fa fa-plus" />
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      className="btn btn-outline-danger btn-sm  wishlistbtn mt-3"
                      style={{ width: "max-content" }}
                      onClick={() => addToWishList(product)}
                    >
                      <i className="fas fa-heart mr-1 " />
                      Move to Wishlist
                    </button>
                  </div>
                  <div className="col-lg-3 col-md-2 col-12 col-sm-12 d-flex flex-column  justify-content-center">
                    <span className="d-flex">
                      <h6 className="ml-1" style={{ marginTop: "-3px", fontWeight: "600" }}>
                        <i class="fas fa-dollar-sign mr-1" />

                        {product.price}
                      </h6>
                    </span>
                  </div>
                  <div className="col-lg-2 col-md-2 col-12 col-sm-12 d-flex flex-column align-items-center justify-content-center">
                    <button
                      className="btn btn-danger btn-sm px-3 mb-2"
                      style={{ width: "max-content" }}
                      onClick={() => removeProduct(product.productId)}
                    >
                      <i className="fa fa-trash mr-1 " />
                      Remove
                    </button>
                  </div>
                </div>
              );
            })}
            <h5 className="text-right mt-3 font-weight-bold">
              Total: <i class="fas fa-dollar-sign mr-1" />
              {total}
            </h5>
          </>
        )}
      </div>
    </>
  );
}
export default Cart;
